import axios from "axios";

//const API_URL = "https://localhost:7177/api"; // your backend root
const API_URL = "https://twofleet.com/api";

const api = axios.create({
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

// Attach token if available
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const signInUser = async(email, password) => {
    const response = await api.post("/auth/login", { email, password });
    return {
        user: response.data.user,
        token: response.data.token,
    };
};

export const deleteAccount = async(password) => {
    const response = await api.delete("/auth/delete", {
        data: { password },
    });
    return response.data;
};

export const signUpUser = async(userData) => {
    const response = await api.post("/auth/register", {
        email: userData.email,
        firstName: userData.firstName,
        lastName: userData.lastName,
        password: userData.password,
        role: userData.role || "User", // 🔑 role defaults to "User"
    });
    return {
        user: response.data.user,
        token: response.data.token,
    };
};

export default api;